import { LoadingButton } from "@mui/lab";
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { approveRequest } from "../../../utils/Requests";
import { GlobalContext } from "../../../GlobalContext";

const ApproveRequest = ({reloading, checked, open, setOpen}) => {
    const { t } = useTranslation('request.form.approve_request')
    const { handlerAlert } = useContext(GlobalContext)

	const [loading, setLoading] = useState(false);

	const closing = () => {
		setOpen(false);
		setLoading(false);
	};

    return (
        <>
            <Dialog
                open={open}
                onClose={() => closing()}
            >
                <DialogTitle>
                    <Typography variant='body3'>{ t('approve_request.title') }</Typography>
                </DialogTitle>

                <DialogContent dividers>
                    <Typography variant='body3'>
                        { checked.length === 1 ? 
                            t('approve_request.message_single')
                            :
                            t('approve_request.message_multiple', { amount: checked.length })
                        }
                    </Typography>
                </DialogContent>

				<DialogActions>
					<LoadingButton
						sx={{ mr: 1.5 }}
						variant="contained"
						disableElevation
						onClick={() => {
							// console.log('checked', checked)
							let promises = checked.map((id) => approveRequest(setLoading, id, handlerAlert, closing));

                            Promise.all(promises)
                            .then(() => {
                                reloading()
                            })
                            .catch(error => {
                                console.error('error', error.message)
                            })
                            .finally(() => {
                                setLoading(false)
                            })
                        }}
                        color='success'
                        loading={loading}
                    >
                        { t('approve_request.buttons.approve') }
                    </LoadingButton>

                    <Button
                        variant='contained'
                        disableElevation
                        onClick={() => closing()}
                        color='error'
                    >
                        { t('approve_request.buttons.cancel') }
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export { ApproveRequest };
